import { For, JSXElement, mergeProps, Show } from 'solid-js';
import { ApplicationTypeEnum } from '~/api';
import MultiAppIcons from './MultiAppIcons';
import { Localized } from '~/i18n';
import { getTranslationKey } from './utils';
import { Tag } from '~/components/ui/Tag';
import { twMerge } from 'tailwind-merge';

type IndividualApplicationContentProps = {
  applicationName: JSXElement;
  description?: JSXElement;
  tagsList?: Array<string>;
  showDescription?: boolean;
  showTagList?: boolean;
  showIcon?: boolean;
  applicationType: ApplicationTypeEnum;
  class?: string;
};

export const IndividualApplicationContent = (
  props: IndividualApplicationContentProps
) => {
  const merged = mergeProps({ showIcon: true }, props);

  return (
    <div class={twMerge(`flex gap-2 items-start`, merged.class)}>
      <div class="flex flex-col gap-2">
        <div class="flex gap-2">
          <div class="flex items-center gap-2 fg-subtle text-sm font-semibold">
            <Show when={merged.showIcon}>
              <MultiAppIcons applicationType={merged.applicationType} />
            </Show>

            {props.applicationName}
          </div>
          <Show when={merged.showTagList}>
            <div class="flex gap-2">
              <For each={props.tagsList}>
                {(tag) => {
                  return (
                    <Tag
                      variant="secondary-brown"
                      class="m-0 py-1"
                    >
                      <Localized translationKey={getTranslationKey(tag)} />
                    </Tag>
                  );
                }}
              </For>
            </div>
          </Show>
        </div>

        <Show when={props.showDescription}>
          <div class="flex flex-col gap-2">
            {props.showDescription && (
              <div class="text-sm font-normal">{props.description}</div>
            )}
          </div>
        </Show>
      </div>
    </div>
  );
};
